import { Pipe, PipeTransform } from '@angular/core';
import { isObject } from '@flexus/utilities';

@Pipe({ name: 'flxObjectValues' })
export class FLXObjectValuesPipe implements PipeTransform {
	transform(value: Object | any[]) {
		if (value && !isObject(value) && Array.isArray(value)) {
			return Object.values(value);
		} else {
			return [];
		}
	}
}
